module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/book-pre-cover-txt--en.250797f7.png";